import authService from "../services/AuthService";

const is_valid_token = () => {
  return authService.isAuthenticated();
};

// Check if user has a non-expired token, or can refresh to get one
const is_authenticated = async () => {
  if (!authService.isAuthenticated()) {
    return false;
  }

  const accessToken = authService.getAccessToken();
  if (!authService.isTokenExpired(accessToken)) {
    return true;
  }

  // Token expired — try refreshing via Okta SDK before giving up
  console.log("Token expired, attempting refresh...");
  try {
    await authService.performTokenRefresh();
    return true;
  } catch (error) {
    console.log("Token refresh failed, clearing authentication");
    authService.logout();
    return false;
  }
};

export { is_valid_token, is_authenticated };
